import React from "react";

import { toast } from "react-toastify";
import RippleLoader from "../../assets/images/loader-circle.svg";
import IconTrue from "../../assets/images/true_new.svg";
import IconError from "../../assets/images/error_icon.svg";

export const LoadingMessage = (title, message) => {
	function Msg() {
		return (
			<div>
				<div className="text-theme-blue font-bold mb-2 flex justify-between items-center">
					<span className="flex items-center">
						<img
							src={RippleLoader}
							alt="Notification"
							className="d-block"
							style={{ width: "20px", height: "20px" }}
						/>
						&nbsp;
						<span className="ml-1">{title}</span>
					</span>
				</div>
				<p
					className="text-gray-400 text-md"
					style={{ lineHeight: "1.3", fontSize: "0.9em" }}>
					{message}
				</p>
			</div>
		);
	}
	toast.dismiss();
	const id = toast(<Msg />, {
		position: "top-right",
		autoClose: false,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
	return id;
};

export const ErrorMessage = (
	title,
	message,
	autoClose = false,
	position = "top-right"
) => {
	function Msg() {
		return (
			<div>
				<div className="text-theme-blue font-bold mb-2 flex justify-between items-center">
					<span className="flex items-center">
						<img
							style={{ width: "20px", height: "20px" }}
							src={IconError}
							alt="Notification"
							className="d-block"
						/>
						<span className="ml-1">{title}</span>
					</span>
				</div>
				<p
					className="text-gray-400 text-md"
					style={{ lineHeight: "1.3", fontSize: "0.9em" }}>
					{message}
				</p>
			</div>
		);
	}
	toast.dismiss();
	toast(<Msg />, {
		position: "top-right",
		autoClose: 3000,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};

export const InfoMessage = (message) => {
	toast.dismiss();
	toast.info(message, {
		position: "top-right",
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};

export const SuccessMessage = (title, message) => {
	function Msg() {
		return (
			<div>
				<div className="text-theme-blue font-bold mb-2 flex justify-between items-center">
					<span className="flex items-center">
						<img src={IconTrue} alt="Notification" className="d-block" />
						&nbsp; &nbsp;
						<span className="ml-1">{title}</span>
					</span>
				</div>
				<p className="text-gray-400 " style={{ lineHeight: "1.3" }}>
					{message}
				</p>
			</div>
		);
	}
	toast.dismiss();
	toast(<Msg />, {
		position: "top-right",
		autoClose: 3000,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};

export const WarningMessage = (message) => {
	toast.dismiss();
	toast.warn(message, {
		position: "top-right",
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};

export const DefaultMessage = (message) => {
	toast.dismiss();
	toast(message, {
		position: "top-right",
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};

export const LoadingSuccess = (title = "", message = "", id, show = false) => {
	function Msg() {
		return (
			<div>
				<div className="text-theme-blue font-bold mb-2 flex justify-between items-center">
					<span className="flex items-center">
						<img src={IconTrue} alt="Notification" className="d-block" />
						&nbsp;
						<span className="ml-1">{title}</span>
					</span>
				</div>
				<p className="text-gray-400 " style={{ lineHeight: "1.3" }}>
					{message}
				</p>
			</div>
		);
	}
	if (!show) return toast.dismiss(id);
	toast.update(id, {
		render: <Msg />,
		autoClose: 3000,
		hideProgressBar: true,
		isLoading: false,
		pauseOnHover: true,
		draggable: true,
		closeButton: true,
	});
};

export const LoadingFail = (title = "", message = "", id) => {
	function Msg() {
		return (
			<div>
				<div className="text-theme-blue font-bold mb-2 flex justify-between items-center">
					<span className="flex items-center">
						<img src={IconError} alt="Notification" className="d-block" />
						&nbsp; &nbsp;
						<span className="ml-1">{title}</span>
					</span>
				</div>
				<p
					className="text-gray-400 text-md"
					style={{ lineHeight: "1.3", fontSize: "0.9em" }}>
					{message}
				</p>
			</div>
		);
	}
	new toast.update(id, {
		render: <Msg />,
		autoClose: 3000,
		hideProgressBar: true,
		isLoading: false,
		pauseOnHover: true,
		draggable: true,
		closeButton: true,
	});
};

export const LoadingMgs = (title, message) => {
	function Msg() {
		return (
			<div>
				<div className="text-theme-blue  mb-2 flex justify-between items-center font-segoe">
					<span className="flex items-center  ">
						<img
							src={RippleLoader}
							width={25}
							height={25}
							alt="Notification"
							className="d-block px-2"
						/>
						&nbsp; &nbsp;
						<span className="ml-1 text-base ">{title}</span>
					</span>
				</div>
				<p className="text-sm font-segoe " style={{ lineHeight: "1.3" }}>
					{message}
				</p>
			</div>
		);
	}
	toast.dismiss();
	toast(<Msg />, {
		position: "top-right",
		autoClose: 2000,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});
};
